import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  LinkedinIcon,
  LinkedinShareButton
} from "react-share";
export const ShareOptions = () => {
  return (
    <>
      <FacebookShareButton
        title="Check out this recall"
        url={window.location.href}>
        <FacebookIcon size={32} round={true} />
      </FacebookShareButton>
      <WhatsappShareButton
        title="Check out this recall"
        url={window.location.href}>
        <WhatsappIcon size={32} round={true} />
      </WhatsappShareButton>
      <EmailShareButton
        subject="Check out this recall"
        url={window.location.href}>
        <EmailIcon size={32} round={true} />
      </EmailShareButton>
      <LinkedinShareButton url={window.location.href}>
        <LinkedinIcon size={32} round={true} />
      </LinkedinShareButton>
    </>
  );
};
